import { AuthInfo } from '@collector/sportsapi-client'
import { EventScout, EventScoutRank } from '@collector/sportsapi-client-legacy'

import { IncidentUpdate } from './queueRabbitClient'

/**
 * Filters incidents updates based on user authentication and scout rank.
 *
 * If the authenticated user is a main scout, returns only incidents from that user.
 * Otherwise, returns all incident updates.
 *
 * @param incidentsUpdate - Array of incident updates to filter
 * @param eventScouts - Array of event scouts
 * @param authInfo - Current user authentication information
 * @returns Filtered array of incident updates
 */
export function filterUserIncidentsUpdate(
  incidentsUpdate: IncidentUpdate[],
  eventScouts: EventScout[],
  authInfo: AuthInfo.AuthInfoType | null,
): IncidentUpdate[] {
  const isMainScout = eventScouts.some(
    (eventScout) =>
      eventScout.scout_id === authInfo?.id &&
      eventScout.rank === EventScoutRank.Main,
  )

  if (isMainScout) {
    return incidentsUpdate.filter(({ source }) => source === authInfo?.id)
  }

  return incidentsUpdate
}
